import React from "react";
import {Redirect, useLocation} from "react-router";


const RedirectSaveCurrentPage = ({to}) => {
  const location = useLocation();

  return <Redirect to={`${to}?redirect=${location.pathname}`} />;
};

export default RedirectSaveCurrentPage;